/* eslint-disable no-console */
'use client';
import type {
  AttributesEntity,
  VariantsEntity,
} from '@eliadmin/core/src/api/products/types/product-types';
import ProductVariantCheckbox from '@eliadmin/core/src/components/product/detail/variants/product-variant-checkbox';
import ProductVariantColor from '@eliadmin/core/src/components/product/detail/variants/product-variant-color';
import ProductVariantRadio from '@eliadmin/core/src/components/product/detail/variants/product-variant-radio';
import { ProductVariantSelect } from '@eliadmin/core/src/components/product/detail/variants/product-variant-select';
import { AttributeType } from '@eliadmin/core/src/stores/category-store';
import {
  sortVariantsByAvailability,
  useVariantsStore,
} from '@eliadmin/core/src/stores/variant-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useEffect } from 'react';

export type ProductVariantsProps = { attributes: AttributesEntity[]; variants: VariantsEntity[] };

export function ProductVariants() {
  const attributes = useVariantsStore(state => state.product.attributes) || [];
  const selectedVariant = useVariantsStore(s => s.selectedVariant);
  const setSelectedVariant = useVariantsStore(s => s.setSelectedVariant);
  const variants = useVariantsStore(state => state.product.variants) || [];

  useEffect(() => {
    /** select first available variant if nothing is selected on mount */
    if (!selectedVariant && variants.length > 0) {
      setSelectedVariant(sortVariantsByAvailability(variants)[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={cn('flex flex-col space-y-5', 'ea-product-detail-variants')}>
      {attributes.map((attribute, i) => {
        if (!Object.values(AttributeType).includes(attribute.type as AttributeType)) {
          console.warn(`Unknown attribute type: ${attribute.type} with id: ${attribute.id}`);
          return null;
        }

        if (attribute.values?.length === 1) return null;

        return (
          <div
            key={`attributes-${attribute.id}`}
            className={cn('flex flex-col gap-2', 'ea-product-detail-variants__attribute')}
          >
            <span className="text-xs font-semibold">
              <strong>{attribute.name}</strong>
            </span>
            {attribute.type === AttributeType.COLOR && (
              <ProductVariantColor key={`attribute-${i}`} attribute={attribute} />
            )}
            {attribute.type === AttributeType.RADIO && (
              <ProductVariantRadio key={`attribute-${i}`} attribute={attribute} />
            )}
            {attribute.type === AttributeType.SELECT && (
              <ProductVariantSelect key={`attribute-${i}`} attribute={attribute} />
            )}
            {attribute.type === AttributeType.CHECKBOX && (
              <ProductVariantCheckbox key={`attribute-${i}`} attribute={attribute} />
            )}
          </div>
        );
      })}
    </div>
  );
}
